import { Component, OnInit,Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-toggleswitch',
  templateUrl: './toggleswitch.component.html',
  styleUrls: ['./toggleswitch.component.scss']
})
export class ToggleswitchComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() checked: any;
  @Input() isSwitchedOn: boolean;
  @Input() readonly: any;
  @Input() page: string|null;

  toggle(evt:MouseEvent){
    evt.stopPropagation()
  }
  
  
  constructor() {
    this.label = this.checked? 'ON' : 'OFF';
   }

  ngOnInit(): void {
    this.label = this.checked? 'ON' : 'OFF';
  }

  ngOnChanges(): void {
    this.label = this.checked? 'ON' : 'OFF';
  }
}
